<template id="selectmap">
  <div class="selectmap" id="container" ref="container"></div>
</template>

<script>
export default {
  name: 'selectmap',
  props: {
    mapLng: {
      type: [Number, String],
      default: 118.60994338989 // 118.60994338989
    },
    mapLat: {
      type: [Number, String],
      default: 39.2111082131 //39.2111082131
    },
    mapAddress: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchService: null,
      map: null,
      marker: null,
      keyWord: '',
      citylocation: null
    };
  },
  created() {
    setTimeout(() => {
      this.init();
    }, 500);
  },
  methods: {
    init() {
      this.map = new qq.maps.Map(this.$refs.container, {
        center: new qq.maps.LatLng(),
        zoom: 13
      });
      this.marker = new qq.maps.Marker({
        position: new qq.maps.LatLng( this.mapLat , this.mapLng),
        map: this.map,
        draggable: true
      });
      // 标记点绑定拖拽方法
      qq.maps.event.addListener(this.marker, 'dragend', (e) => {
        this.callBackAdress(e.latLng);
      });
      // 地图绑定点击事件
      qq.maps.event.addListener(this.map, 'click', (event) => {
        this.callBackAdress(event.latLng);
        this.marker.setPosition(event.latLng);
      });
    },
    //位置搜索
    searchKeyword() {
      this.citylocation = new qq.maps.CityService({
        map: this.map,
        complete: (results) => {
          console.log(results);
          if (results.type == 'AREA_INFO') {
            this.cityService(results.detail.name);
          }
        }
      });
      if (this.keyWord != this.mapAddress) {
        this.citylocation.searchLocalCity();
      }
    },
    cityService(cityName) {
      this.searchService = new qq.maps.SearchService({
        pageIndex: 1,
        pageCapacity: 10,
        autoExtend: false,
        location: cityName,
        complete: (res) => {
          console.log(res);
          if (res.type == 'POI_LIST') {
            if (res.detail.pois && res.detail.pois.length) {
              const adress = res.detail.pois[0];
              this.map.fitBounds(new qq.maps.LatLngBounds().extend(adress.latLng));
              this.marker.setPosition(adress.latLng);
              // this.callBackAdress(adress.latLng);
              this.keyWord = adress.address;
              this.$emit('clickmap', adress.address, adress.latLng.lat, adress.latLng.lng);
            } else {
              this.$baseMessage('当前位置无法检测！', 'warning');
            }
          } else if (res.type == 'CITY_LIST') {
            this.$baseMessage('当前位置无法检测！！', 'warning');
          }
        }
      });
      this.searchService.search(this.mapAddress);
    },
    // 坐标返回
    callBackAdress(msg) {
      this.$api.get(
        'delivery/store/map',
        {
          lat: msg.lat,
          lng: msg.lng
        },
        (res) => {
          if (res.status == 0) {
            this.keyWord = res.result.address;
            this.$emit('clickmap', res.result.address, msg.lat, msg.lng);
          } else {
          }
        }
      );
    }
  }
};
</script>

<style lang="scss">
#container {
  min-width: 500px;
  width: auto;
  height: 350px;
}
</style>